import { render } from "./BubbleOne.vue?vue&type=template&id=cbec13a6"
import script from "./BubbleOne.vue?vue&type=script&lang=js"
export * from "./BubbleOne.vue?vue&type=script&lang=js"

import "./BubbleOne.vue?vue&type=style&index=0&id=cbec13a6&lang=css"
script.render = render

export default script